const CLARITY_ID = 'wxs2m5ss41'

declare global {
  interface Window {
    clarity?: any
  }
}

function loadClarity() {
  if (typeof window === 'undefined') return
  if (window.clarity) return
  const w = window as any
  w.clarity =
    w.clarity ||
    function () {
      ;(w.clarity.q = w.clarity.q || []).push(arguments)
    }
  const t = document.createElement('script')
  t.async = true
  t.src = 'https://www.clarity.ms/tag/' + CLARITY_ID
  ;(document.head || document.documentElement).appendChild(t)
}

export function initClarity() {
  if (typeof window === 'undefined') return
  const run = () => loadClarity()
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(run, { timeout: 2000 })
  } else {
    setTimeout(run, 200)
  }
}
